export const TANULMANYI_KORULMENYEK_TRANSLATIONS = {
    hu: {
        esgTitle: "ESG 1.6 Tanulástámogatás és hallgatói szolgáltatások",
        sectionTitle: "13. A képzés tanulmányi körülményei",
        szakmentonRendszer: "Szakmentori rendszer működése",
        tanulmanyiTablazatok: "Tanulmányi táblázatok (mintatanterv, követelmények)",
        oktatoiKonzultacio: "Oktatói konzultáció lehetőségek elérhetősége",
        felzarkoztatoKepzesek: "Felzárkóztató képzések",
        tehetseggondozasiLehetosegek: "Tehetséggondozási lehetőségek",
        szakmaiGyakorlat: "Szakmai gyakorlat támogatása",
        oktatoiSegedanyagok: "Oktatási segédanyagok fejlesztése",
        digitalisTananyagok: "Digitális tananyagok (LMS, e-learning)",
        digitalisEszkozok: "Digitális eszközök/szoftverek rendelkezésre állása",
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden mezőt ki kell tölteni!"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        esgTitle: "ESG 1.6 Learning Support and Student Services",
        sectionTitle: "13. Academic Conditions of the Program",
        szakmentonRendszer: "Operation of the programme mentoring system",
        tanulmanyiTablazatok: "Academic information provision (sample curriculum, requirements)",
        oktatoiKonzultacio: "Availability of teaching staff consultation opportunities",
        felzarkoztatoKepzesek: "Remedial support opportunities",
        tehetseggondozasiLehetosegek: "Talent development opportunities",
        szakmaiGyakorlat: "Support for internships",
        oktatoiSegedanyagok: "Development of teaching support materials",
        digitalisTananyagok: "Digital learning materials (LMS, e-learning)",
        digitalisEszkozok: "Availability of digital tools / software",
        
        buttons: {
            previous: "Previous section",
            next: "Next section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw finalization"
        },
        
        alerts: {
            requiredFields: "All fields must be filled!"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
